import {SecurityKey} from '../../../../../../../../models/security-key';
import {WidgetHeaderTitlePart} from '../../widget-header-title';

export const W_HEADER_TITLE_PART_SYMBOL_TYPE = 'SYMBOL';

export interface WHeaderTitlePartSymbolData {
    securityKey: SecurityKey;
    altSecurityKey?: SecurityKey; // [TT-247] Handle Smart security (workaround) in Chart
}

export type WHeaderTitlePartSymbol = WidgetHeaderTitlePart<typeof W_HEADER_TITLE_PART_SYMBOL_TYPE,
    WHeaderTitlePartSymbolData>;

export const createWHeaderTitlePartSymbol = (
    securityKey: SecurityKey,
    altSecurityKey?: SecurityKey
): WHeaderTitlePartSymbol => ({
    type: W_HEADER_TITLE_PART_SYMBOL_TYPE,
    data: {
        securityKey,
        altSecurityKey
    }
});
